"use client";

import { useState } from "react";

import { BottomRow } from "@/components/audioPlayers/audioPlayerDownloadIsolation/BottomRow";
import { Details } from "@/components/audioPlayers/audioPlayerDownloadIsolation/Details";
import { DoneIsolation } from "@/components/audioPlayers/audioPlayerDownloadIsolation/DoneIsolation";
import { FailedIsolation } from "@/components/audioPlayers/audioPlayerDownloadIsolation/FailedIsolation";
import { NotDoneIsolation } from "@/components/audioPlayers/audioPlayerDownloadIsolation/NotDoneIsolation";
import { IsolationConstructedNoDates, UserNoDates } from "@/types/types";

export function AudioPlayerDownloadIsolation({
  isolation,
  user,
}: {
  isolation: IsolationConstructedNoDates;
  user: UserNoDates;
}) {
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-3xl bg-white px-4 py-2 shadow-sm ring-1 ring-gray-900/5">
      {isolation.failed && <FailedIsolation isolation={isolation} />}

      {!isolation.failed && isolation.confirmedDone && (
        <DoneIsolation isolation={isolation} user={user} />
      )}

      {!isolation.failed && !isolation.confirmedDone && (
        <NotDoneIsolation isolation={isolation} />
      )}

      <BottomRow isolation={isolation} open={open} setOpen={setOpen} />

      {open && <Details isolation={isolation} />}
    </div>
  );
}
